import { BLACK_500, BLACK_900, BLUE_400, BLUE_500, BLUE_600, BLUE_GREY_400, BLACK_800 } from '../colors';
var radioConfig = {
  label: '',
  isBoldLabel: false,
  labelPosition: 'right',
  spacing: 'SPACING_8',
  size: 'sm',
  disabled: false,
  checked: false,
  style: {},
  controlState: 'none',
  radioDisplay: 'block',
  config: {
    size: {
      sm: {
        radioSize: 16,
        labelFontType: 'body-para-sm',
        descriptionFontType: 'body-para-xs'
      },
      md: {
        radioSize: 20,
        labelFontType: 'body-para-md',
        descriptionFontType: 'body-para-sm'
      },
      lg: {
        radioSize: 24,
        labelFontType: 'body-para-lg',
        descriptionFontType: 'body-para-md'
      }
    },
    controlState: {
      none: {
        borderColor: BLUE_500,
        color: BLUE_500,
        labelColor: BLACK_900,
        descriptionColor: BLACK_900
      },
      disabled: {
        borderColor: BLACK_500,
        color: BLACK_500,
        labelColor: BLACK_500,
        descriptionColor: BLACK_500
      },
      hover: {
        borderColor: BLUE_400,
        color: BLUE_400,
        labelColor: BLACK_900,
        descriptionColor: BLACK_900
      },
      pressed: {
        borderColor: BLUE_600,
        color: BLUE_600,
        labelColor: BLACK_900,
        descriptionColor: BLACK_900
      }
    }
  }
};
var radioConfigWhite = Object.assign(Object.assign({}, radioConfig), {
  config: {
    size: {
      sm: {
        radioSize: 16,
        labelFontType: 'body-para-sm',
        descriptionFontType: 'body-para-xs'
      },
      md: {
        radioSize: 20,
        labelFontType: 'body-para-md',
        descriptionFontType: 'body-para-sm'
      },
      lg: {
        radioSize: 24,
        labelFontType: 'body-para-lg',
        descriptionFontType: 'body-para-md'
      }
    },
    controlState: {
      none: {
        borderColor: BLUE_500,
        color: BLUE_500,
        labelColor: BLACK_900,
        descriptionColor: BLACK_800
      },
      disabled: {
        borderColor: BLUE_GREY_400,
        color: BLUE_GREY_400,
        labelColor: BLUE_GREY_400,
        descriptionColor: BLUE_GREY_400
      },
      hover: {
        borderColor: BLUE_400,
        color: BLUE_400,
        labelColor: BLACK_900,
        descriptionColor: BLACK_800
      },
      pressed: {
        borderColor: BLUE_600,
        color: BLUE_600,
        labelColor: BLACK_900,
        descriptionColor: BLACK_800
      }
    }
  }
});
export default {
  light: radioConfig,
  dark: radioConfig,
  white: radioConfigWhite
};